import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getWorkOrdersForTagSlice } from "../../services/wo";
import {
  SeverityType,
  Status,
  WonosStatusResponse,
  SceCtoProps,
} from "../../types";

export interface TagsAndWorkOrdersState {
  selectedTag: string;
  workOrders: WonosStatusResponse[];
  alarmStatus: Status;
  ctos: SceCtoProps;
  isLoadingWorkOrders: boolean;
}

export const tagsAndWorkOrdersSlice = createSlice({
  name: "tagsAndWorkOrders",

  initialState: {
    selectedSce: "",
    sceName: "",
    mahName: "",
    barrierId: "",
    originName: "",
    alarmStatus: SeverityType.NoInfo,
    ctos: {
      ongoing: [],
      notStarted: [],
    },
    selectedTag: "",
    workOrders: [],
    correlationsByWorkOrderId: {},
    isLoadingTags: true,
    isLoadingWorkOrders: true,
    isLoadingCurrentTagCorrectives: false,
    isSavingPriority: false,
    savePrioritySuccess: null,
    isLoadingWorkOrderCorrelations: false,
    isSavingDelete: false,
    saveDeleteSuccess: null,
  } as TagsAndWorkOrdersState,

  reducers: {
    setWorkOrders: (state, action) => {
      state.workOrders = action.payload;
    },

    setSelectedTag: (state, action) => {
      state.selectedTag = action.payload;
    },

    setIsLoadingWorkOrders: (state, action) => {
      state.isLoadingWorkOrders = action.payload;
    },
  },
});

interface FetchWorkOrdersForTagProps {
  vesselId: string;
  selectedTag: string;
}

const fetchWorkOrdersForTag = createAsyncThunk<
  void,
  FetchWorkOrdersForTagProps,
  object
>(
  "tagsAndWorkOrders/fetchWorkOrders",
  async ({ vesselId, selectedTag }, { dispatch }) => {
    dispatch(tagsAndWorkOrdersSlice.actions.setIsLoadingWorkOrders(true));
    dispatch(tagsAndWorkOrdersSlice.actions.setWorkOrders([]));
    const wonosForTag = await getWorkOrdersForTagSlice(vesselId, selectedTag);
    dispatch(tagsAndWorkOrdersSlice.actions.setWorkOrders(wonosForTag));
    dispatch(tagsAndWorkOrdersSlice.actions.setIsLoadingWorkOrders(false));
  },
);

export const thunks = {
  fetchWorkOrdersForTag,
};

export const actions = {
  ...tagsAndWorkOrdersSlice.actions,
  ...thunks,
};
